// extracted by mini-css-extract-plugin
export default {"checkboxFloatingLblRow":"shift-form_checkboxFloatingLblRow__jmPCn","formCheck":"shift-form_formCheck__csOC9"};